
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/easing.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_Skeleton";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_Skeleton__root","line":"wds_1_209_0_Skeleton__line","chunk":"wds_1_209_0_Skeleton__chunk"};
export var keyframes = {"moveRight":"wds_1_209_0_Skeleton__moveRight"}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




